import { css } from 'styled-components';
import { CFTokens } from '../tokens';
//
// This mixin allows a spacer object (see CFSpacerSchema) to be passed in
// and a corresponding collection of CSS margin settings will be returned.
// The CFTokens.getCFSpacerValue() utility ensures only system values are output.
//
export const spacer = ({ spacer }) => spacer &&
    css `
    ${spacer.top &&
        css `
      margin-top: ${CFTokens.getCFSpacerValue(spacer.top)}px;
    `};
    ${spacer.right &&
        css `
      margin-right: ${CFTokens.getCFSpacerValue(spacer.right)}px;
    `};
    ${spacer.bottom &&
        css `
      margin-bottom: ${CFTokens.getCFSpacerValue(spacer.bottom)}px;
    `};
    ${spacer.left &&
        css `
      margin-left: ${CFTokens.getCFSpacerValue(spacer.left)}px;
    `};
  `;
//
// This mixin parses a `padding` setting and outputs the appropriate padding values
//
export const padding = (padding) => {
    // Skip of padding is not truthy
    if (!padding) {
        return;
    }
    // If the SpacerSchema is used we may have any individual side specified
    if (CFTokens.isCFSpacerSchema(padding)) {
        const { top, right, bottom, left } = padding;
        return css `
      ${top
            ? css `
            padding-top: ${CFTokens.getCFSpacerValue(top)}px;
          `
            : ''};
      ${right
            ? css `
            padding-right: ${CFTokens.getCFSpacerValue(right)}px;
          `
            : ''};
      ${bottom
            ? css `
            padding-bottom: ${CFTokens.getCFSpacerValue(bottom)}px;
          `
            : ''};
      ${left
            ? css `
            padding-left: ${CFTokens.getCFSpacerValue(left)}px;
          `
            : ''};
    `;
    }
    // If the SpacerSimpleSchema is provided we may have shorthand for vertical or horiztonal sides specified
    if (CFTokens.isCFSpacerSimpleSchema(padding)) {
        const { vertical, horizontal } = padding;
        return css `
      ${vertical
            ? css `
            padding-top: ${CFTokens.getCFSpacerValue(vertical)}px;
            padding-bottom: ${CFTokens.getCFSpacerValue(vertical)}px;
          `
            : ''};
      ${horizontal
            ? css `
            padding-right: ${CFTokens.getCFSpacerValue(horizontal)}px;
            padding-left: ${CFTokens.getCFSpacerValue(horizontal)}px;
          `
            : ''};
    `;
    }
    // Otherwise we'll treat the value as intended to apply to all sides
    return css `
    padding: ${CFTokens.getCFSpacerValue(padding)}px;
  `;
};
